import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';
import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import { TestElement } from '@oracle/oraclejet-testing/UNSAFE_Driver';

type InputsWithLabels = {
  label: TestElement;
  input: TestElement;
};
export class CheckboxSetAdapter extends TestAdapter {
  /**
   * Retrieves all inputs with type="checkbox" and their labels.
   * @private
   * @returns Promise<InputsWithLabels[]>
   */
  private async _getInputsWithLabels(): Promise<InputsWithLabels[]> {
    const el = await this.getElement();
    const labels = await el.waitForElements(byCss('li label'));

    return Promise.all(
      labels.map(async (label) => ({
        label,
        input: await label.waitForElement(byCss('input[type="checkbox"]'))
      }))
    );
  }

  /**
   * Change the value of the component.
   * @param value {Set<string | number> | undefined} The new value.
   * @returns Promise<void>
   */
  async changeValue(value: Set<string | number> | undefined) {
    const driver = this.getTestDriver();
    const inputsWithLabels = await this._getInputsWithLabels();

    await Promise.all(
      inputsWithLabels.map(async ({ label, input }) => {
        const inputValue = (await input.getAttribute('value')) ?? '';
        const isChecked = (await input.getAttribute('aria-checked')) === 'true';
        const shouldBeChecked = (value?.has(inputValue) || value?.has(+inputValue)) ?? false;

        if (isChecked !== shouldBeChecked) {
          await driver.click(label);
        }
      })
    );
  }

  /**
   * Clear the value of the component.
   * @returns Promise<void>
   */
  async clear() {
    await this.changeValue(undefined);
  }
}
